var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "page-main has-bottom" },
        [
          _c("page-title", {
            attrs: { back: true },
            on: { goback: _vm.goback },
          }),
          _vm._v(" "),
          _c(
            "page-card",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { "margin-bottom": "32px" },
            },
            [
              _c("template", { slot: "header" }, [
                _vm._v("Producer Information"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { slot: "body" }, slot: "body" },
                [
                  _c("base-info", {
                    attrs: { pageData: _vm.pageData },
                    on: {
                      "update:pageData": function ($event) {
                        _vm.pageData = $event
                      },
                      "update:page-data": function ($event) {
                        _vm.pageData = $event
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "add-header" }, [
                    _vm._v("Well Information"),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.wellList, function (well, index) {
                    return _c("wellComp", {
                      key: "well" + index,
                      attrs: { pageData: well, wellIndex: index },
                    })
                  }),
                ],
                2
              ),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "page-bottom",
        [
          [
            _vm.$route.query.type === "reject"
              ? _c(
                  "div",
                  { staticClass: "page-btns" },
                  [
                    _c("loading-btn", {
                      attrs: { type: "primary", label: "Submit" },
                      on: {
                        clickHandle: function ($event) {
                          return _vm.handleSubmit($event, 1)
                        },
                      },
                    }),
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "page-btns" },
                  [
                    _c("loading-btn", {
                      attrs: { type: "primary", label: "Reject" },
                      on: {
                        clickHandle: function ($event) {
                          return _vm.reject($event, 6)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("loading-btn", {
                      attrs: { type: "primary", label: "Approval" },
                      on: {
                        clickHandle: function ($event) {
                          return _vm.approval($event, 1)
                        },
                      },
                    }),
                  ],
                  1
                ),
          ],
        ],
        2
      ),
      _vm._v(" "),
      _c("editInformationSuccess", {
        ref: "editInformationSuccess",
        attrs: { noTip: true, msg: "Approved completed!" },
        on: { close: _vm.goback },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }